import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
}

export default function ExitConfirmationDialog({ onCancel, onConfirm, open }: Props) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Exit Set up Flash offer?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Any information entered in this wizard will be lost and this action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
